<template>
<div id="mask-layer-wrap" :class="isShowPopup && 'cur'" @click="isShowPopup = false">
    <img class="mask-img" :src="Images.img_share_prompt" />
</div>
</template>

<script>
export default {
    name: "SharePopup",
    data() {
        return {
            isShowPopup: false,
            value: false,
        };
    },
    methods: {
        _onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if(!url) return;
            window.location.href = url;
        },

        _show(value) {
            this.value = value;
            if (this.$isWeiXin()) {
                this.isShowPopup = true;
            } else {
                this.ToastManager('请使用浏览器分享按钮进行分享');
            }
        },
    }
};
</script>

<style lang="less" scoped>
#mask-layer-wrap {
    top: 0px;
    left: 0px;
    right: 0px;
    display: none;
    bottom: -200px;
    z-index: 999999;
    position: fixed;
    text-align: right;
    padding-right: 25px;
    background: rgba(0, 0, 0, 0.6);

    &.cur {
        display: block;
    }

    img {
        max-width: 100%;
        margin-top: 1rem;
    }
}
</style>